import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconThumbsDown: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"thumbs-down, thumb, hand, no, contra"} maskId="square-filled-radius-0-stroke-1-IconThumbsDown"><path fillRule="evenodd" clipRule="evenodd" d="M18.0487 4V13H21.0487V4H18.0487ZM17.8396 14H22.0487V3H6.58118C4.87481 3 3.41714 4.23052 3.13081 5.9127L2.15209 11.6627C1.78835 13.7996 3.43479 15.75 5.60246 15.75H10.4477L9.91856 19.1112C9.67974 20.6283 10.8524 22 12.3881 22H13.2912L17.8396 14Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconThumbsDown;
